var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWebinar({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 42,
    viewBox: "0 0 59 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.5502 28.1354C39.4302 25.6954 34.6402 24.2754 29.5002 24.2754C24.3602 24.2754 19.5702 25.6954 15.4502 28.1354C15.4702 28.1754 15.5102 28.2054 15.5302 28.2354C15.5002 28.2554 15.4802 28.2654 15.4502 28.2754C18.5902 32.6454 23.7002 35.5054 29.5002 35.5054C35.3002 35.5054 40.4102 32.6454 43.5502 28.2754C43.5202 28.2554 43.5002 28.2454 43.4702 28.2354C43.5002 28.2054 43.5302 28.1754 43.5502 28.1354Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5002 20.8952C33.4102 20.8952 36.5901 17.7252 36.5901 13.8052C36.5901 13.7852 36.5901 13.7552 36.5901 13.7352C36.5901 13.7152 36.5901 13.6852 36.5901 13.6652C36.5901 9.75519 33.4202 6.5752 29.5002 6.5752C25.5802 6.5752 22.4102 9.74519 22.4102 13.6652C22.4102 13.6852 22.4102 13.7152 22.4102 13.7352C22.4102 13.7552 22.4102 13.7852 22.4102 13.8052C22.4102 17.7152 25.5802 20.8952 29.5002 20.8952Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.12018 41.425C3.68018 35.985 0.680176 28.745 0.680176 21.045C0.680176 13.345 3.68018 6.11504 9.12018 0.665039L10.7402 2.28503C5.73017 7.29503 2.97015 13.955 2.97015 21.035C2.97015 28.115 5.73017 34.775 10.7402 39.785L9.12018 41.405V41.425Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.41 37.1351C9.10997 32.8351 6.75 27.1251 6.75 21.0451C6.75 14.9651 9.11997 9.25508 13.41 4.95508L15.03 6.57509C11.17 10.4351 9.03998 15.5751 9.03998 21.0451C9.03998 26.5151 11.17 31.6451 15.03 35.5151L13.41 37.1351Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M49.8802 41.4246L48.2603 39.8046C53.2703 34.7946 56.0302 28.1346 56.0302 21.0546C56.0302 13.9746 53.2703 7.30458 48.2603 2.30458L49.8802 0.68457C55.3202 6.12457 58.3203 13.3646 58.3203 21.0646C58.3203 28.7646 55.3202 35.9946 49.8802 41.4446V41.4246Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M45.5902 37.1351L43.9702 35.5151C47.8302 31.6451 49.9603 26.5151 49.9603 21.0451C49.9603 15.5751 47.8302 10.4451 43.9702 6.57509L45.5902 4.95508C49.8902 9.25508 52.2603 14.9651 52.2603 21.0451C52.2603 27.1251 49.8902 32.8351 45.5902 37.1351Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebinar);
export default __webpack_public_path__ + "static/media/webinar.cd24ce6c3bf3973af1ae030bd61c0832.svg";
export { ForwardRef as ReactComponent };